

// import React, { useState, useEffect } from "react";
// import { FaBars, FaTimes, FaHome, FaBriefcase, FaFileAlt, FaSearch, FaUntappd, FaVideo } from "react-icons/fa";
// import { Chart as ChartJS, ArcElement, BarElement, LineElement, CategoryScale, LinearScale, PointElement, Title, Tooltip, Legend } from "chart.js";
// import { Bar, Line, Pie, Doughnut } from "react-chartjs-2";
// import { useSearchParams } from "react-router-dom";
// import { useParams } from "react-router-dom";

// import Header from "../../../component/Header";
// import MyJobListingTable from "./MyJobListingTable";
// import { FaEmpire, FaLetterboxd, FaSquareLetterboxd, FaUber } from "react-icons/fa6";
// import LetterBanner from "../letters/LetterBanner";
// import MySearch from "./MySearches";
// import Profile from "./Profile";
// import Dashboardhome from "./Dashboardhome"; 
// import UrgentStaff from "./UrgentStaff";
// import EmployerEmployee from "../EmployerEmployee";
// import EmployerDashboard from "../EmployerDashboard";
// import ApplicationsDashboard from "./ApplicationDashboard";
// import ReviewEmployeeModal from "./EmployeeReview";
// import SentLetters from "./SentLetters";
// import VideoPostForm from "../../../Admin/PostVideo";
// import ApplicantsDashboard from "./ApplicantDashboard";
// import StaffAssessmentPage from "./AssessmentPage";

// // Register Chart.js components
// ChartJS.register(ArcElement, BarElement, LineElement, CategoryScale, LinearScale, PointElement, Title, Tooltip, Legend);

// // Placeholder components (unchanged)
// const JobsList = () => (
//   <div className="p-6">
//     <h2 className="text-2xl font-bold text-gray-900 mb-6">Jobs List</h2>
//     <p className="text-gray-600"><MyJobListingTable /></p>
//   </div>
// );

// const Applications = () => (
//   <div className="p-6">
//     <h2 className="text-2xl font-bold text-gray-900 mb-6">Applications</h2>
//     <p className="text-gray-600">Manage job applications here.</p>
//   </div>
// );

// const Users = () => (
//   <div className="p-6">
//     <h2 className="text-2xl font-bold text-gray-900 mb-6">Users</h2>
//     <p className="text-gray-600">User management section.</p>
//   </div>
// );

// const Settings = () => (
//   <div className="p-6">
//     <h2 className="text-2xl font-bold text-gray-900 mb-6">Settings</h2>
//     <p className="text-gray-600">Configure platform settings.</p>
//   </div>
// );

// const JobDashboard = () => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [activeComponent, setActiveComponent] = useState("Dashboard");

//   const { id } = useParams();  
//   const [searchParams, setSearchParams] = useSearchParams();
//   const activeContent = searchParams.get('tab') || 'Dashboard';

//   const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

//   // Sync URL with activeComponent when component changes (and vice versa)
//   useEffect(() => {
//     if (activeContent && activeContent !== activeComponent) {
//       setActiveComponent(activeContent);
//     }
//   }, [activeContent]);

//   const sidebarItems = [
//     { icon: <FaHome />, label: "Dashboard", component: "Dashboard" },
//     { icon: <FaBriefcase />, label: "Post a New Job", component: "Users" },
//     { icon: <FaBriefcase />, label: "Manage Job Listing", component: "Jobs" },
//     // { icon: <FaFileAlt />, label: "View Job Applications", component: "Applications" },
//     { icon: <FaEmpire />, label: "Manage Staff Profiles", component: "staff" },
//     { icon: <FaLetterboxd />, label: "Send Automated Messages?", component: "Letters" },
//     { icon: <FaLetterboxd />, label: "Create Applicant Manually", component: "Applicants" },
//     { icon: <FaUntappd />, label: "Update  staff status", component: "update" },
//     { icon: <FaUntappd />, label: "Staff Review & Feedbacks?", component: "review" },
//     { icon: <FaSearch />, label: "Search Database", component: "Searches" },
//     { icon: <FaSquareLetterboxd />, label: "Assessment", component: "staffAssessment" },
//     // { icon: <FaUber />, label: "Urgent Staff Request", component: "urgent" },
//     // { icon: <FaVideo />, label: "Upload a video", component: "video" },
//   ];

//   const renderComponent = () => {
//     switch (activeContent) {   // Using activeContent from URL (recommended)
//       case "Dashboard":
//         return <Dashboardhome />;
//       case "Applicants":
//         return <ApplicantsDashboard />;
//       case "Jobs":
//         return <JobsList />;
//       case "staff":
//         return <EmployerEmployee />;
//       case "Letters":
//         return <LetterBanner />;
//       case "update":
//         return <EmployerDashboard />;
//       case "Searches":
//         return <MySearch />;
//       case "staffAssessment":
//         return <StaffAssessmentPage />;
//       // case "letterSent":
//       //   return <SentLetters />;
//       case "urgent":
//         return <UrgentStaff />;
//       case "Applications":
//         return <ApplicationsDashboard />;
//       case "Users":
//         return <Profile />;
//       case "video":
//         return <VideoPostForm />;
//       case "review":
//         return <ReviewEmployeeModal />;
//       case "Settings":
//         return <Settings />;
//       default:
//         return <Dashboardhome />;
//     }
//   };

//   return (
//     <>
//       <div className="flex h-screen bg-gray-50">
//         <Header toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />

//         {/* Mobile Toggle Button */}
//         <button
//           className="md:hidden fixed top-4 left-4 z-50 p-3 bg-white rounded-full shadow-lg text-gray-700 hover:text-orange-500 transition-colors"
//           onClick={toggleSidebar}
//           aria-label="Toggle sidebar"
//         >
//           {isSidebarOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
//         </button>

//         {/* Sidebar */}
//         <div
//           className={`
//             fixed inset-y-0 left-0 z-40 w-64 bg-white shadow-2xl 
//             transform transition-transform duration-300 ease-in-out
//             ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}
//             md:translate-x-0 md:static md:shadow-none mt-10
//           `}
//         >
//           <div className="flex items-center justify-between p-4 md:hidden">
//             <button 
//               onClick={toggleSidebar}
//               className="text-gray-700 hover:text-orange-500 transition-colors"
//             >
//               <FaTimes size={24} />
//             </button>
//           </div>

//           <nav className="mt-4 md:mt-8">
//             <ul>
//               {sidebarItems.map((item, index) => (
//                 <li key={index}>
//                   <button
//                     onClick={() => {
//                       setActiveComponent(item.component);           // Keep your original state
//                       setSearchParams({ tab: item.component });     // ← Added: Update URL with ?tab=
//                       setIsSidebarOpen(false);
//                     }}
//                     className={`
//                       flex items-center w-full px-6 py-4 
//                       text-gray-700 hover:bg-orange-50 hover:text-orange-500 
//                       transition-colors duration-200
//                       ${activeComponent === item.component 
//                         ? "bg-orange-500 text-white" 
//                         : ""
//                       }
//                     `}
//                   >
//                     <span className="text-lg">{item.icon}</span>
//                     <span className="ml-4 font-semibold">{item.label}</span>
//                   </button>
//                 </li>
//               ))}
//             </ul>
//           </nav>
//         </div>

//         {/* Overlay */}
//         {isSidebarOpen && (
//           <div
//             className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
//             onClick={toggleSidebar}
//           />
//         )}

//         {/* Main Content */}
//         <div className="flex-1 overflow-y-auto">
//           <header className="flex items-center justify-between p-4 bg-white shadow-md md:hidden">
//             <button onClick={toggleSidebar}>
//               <FaBars size={24} className="text-gray-600 hover:text-e-ride-purple transition-colors duration-200" />
//             </button>
//           </header>

//           {/* Rendered Component */}
//           {renderComponent()}
//         </div>
//       </div>
//     </>
//   );
// };

// export default JobDashboard;






import React, { useState, useEffect } from "react";
import { FaBars, FaTimes, FaHome, FaBriefcase, FaFileAlt, FaSearch, FaUntappd, FaVideo } from "react-icons/fa";
import { Chart as ChartJS, ArcElement, BarElement, LineElement, CategoryScale, LinearScale, PointElement, Title, Tooltip, Legend } from "chart.js";
import { Bar, Line, Pie, Doughnut } from "react-chartjs-2";
import { useSearchParams } from "react-router-dom";
import { useParams } from "react-router-dom";

import Header from "../../../component/Header";
import MyJobListingTable from "./MyJobListingTable";
import { FaEmpire, FaLetterboxd, FaSquareLetterboxd, FaUber } from "react-icons/fa6";
import LetterBanner from "../letters/LetterBanner";
import MySearch from "./MySearches";
import Profile from "./Profile";
import Dashboardhome from "./Dashboardhome"; 
import UrgentStaff from "./UrgentStaff";
import EmployerEmployee from "../EmployerEmployee";
import EmployerDashboard from "../EmployerDashboard";
import ApplicationsDashboard from "./ApplicationDashboard";
import ReviewEmployeeModal from "./EmployeeReview";
import SentLetters from "./SentLetters";
import VideoPostForm from "../../../Admin/PostVideo";
import ApplicantsDashboard from "./ApplicantDashboard";
import StaffAssessmentPage from "./AssessmentPage";
import VerificationHub from "../../IdentityVerification";

// Register Chart.js components
ChartJS.register(ArcElement, BarElement, LineElement, CategoryScale, LinearScale, PointElement, Title, Tooltip, Legend);

// Placeholder components (unchanged)
const JobsList = () => (
  <div className="p-6">
    <h2 className="text-2xl font-bold text-gray-900 mb-6">Jobs List</h2>
    <p className="text-gray-600"><MyJobListingTable /></p>
  </div>
);

const Applications = () => (
  <div className="p-6">
    <h2 className="text-2xl font-bold text-gray-900 mb-6">Applications</h2>
    <p className="text-gray-600">Manage job applications here.</p>
  </div>
);

const Users = () => (
  <div className="p-6">
    <h2 className="text-2xl font-bold text-gray-900 mb-6">Users</h2>
    <p className="text-gray-600">User management section.</p>
  </div>
);

const Settings = () => (
  <div className="p-6">
    <h2 className="text-2xl font-bold text-gray-900 mb-6">Settings</h2>
    <p className="text-gray-600">Configure platform settings.</p>
  </div>
);

const JobDashboard = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeComponent, setActiveComponent] = useState("Dashboard");

  const { id } = useParams();  
  const [searchParams, setSearchParams] = useSearchParams();
  const activeContent = searchParams.get('tab') || 'Dashboard';

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  useEffect(() => {
    if (activeContent && activeContent !== activeComponent) {
      setActiveComponent(activeContent);
    }
  }, [activeContent]);

  const sidebarItems = [
    { icon: <FaHome />, label: "Dashboard", component: "Dashboard" },
    { icon: <FaBriefcase />, label: "Post a New Job", component: "Users" },
    { icon: <FaBriefcase />, label: "Manage Job Listing", component: "Jobs" },
    { icon: <FaEmpire />, label: "Manage Staff Profiles", component: "staff" },
    { icon: <FaLetterboxd />, label: "Send Automated Messages?", component: "Letters" },
    { icon: <FaLetterboxd />, label: "Create Applicant Manually", component: "Applicants" },
    { icon: <FaUntappd />, label: "Update staff status", component: "update" },
    { icon: <FaUntappd />, label: "Staff Review & Feedbacks?", component: "review" },
    { icon: <FaSearch />, label: "Search Database", component: "Searches" },
    { icon: <FaSquareLetterboxd />, label: "Assessment", component: "staffAssessment" },
    { icon: <FaSquareLetterboxd />, label: "Verification", component: "verify" },
  ];

  const renderComponent = () => {
    switch (activeContent) {
      case "Dashboard": return <Dashboardhome />;
      case "Applicants": return <ApplicantsDashboard />;
      case "Jobs": return <JobsList />;
      case "staff": return <EmployerEmployee />;
      case "Letters": return <LetterBanner />;
      case "update": return <EmployerDashboard />;
      case "Searches": return <MySearch />;
      case "staffAssessment": return <StaffAssessmentPage />;
      case "urgent": return <UrgentStaff />;
      case "Applications": return <ApplicationsDashboard />;
      case "Users": return <Profile />;
      case "video": return <VideoPostForm />;
      case "review": return <ReviewEmployeeModal />;
      case "Settings": return <Settings />;
      case "verify": return <VerificationHub />;
      default: return <Dashboardhome />;
    }
  };

  return (
    <>
      <div className="flex h-screen bg-gray-50">
        <Header toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />

        {/* Mobile Toggle Button */}
        <button
          className="md:hidden fixed top-4 left-4 z-50 p-3 bg-white rounded-full shadow-lg text-gray-700 hover:text-orange-500 transition-colors"
          onClick={toggleSidebar}
          aria-label="Toggle sidebar"
        >
          {isSidebarOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button>

        {/* Sidebar - Now Scrollable */}
        <div
          className={`
            fixed inset-y-0 left-0 z-40 w-64 bg-white shadow-2xl 
            transform transition-transform duration-300 ease-in-out
            ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}
            md:translate-x-0 md:static md:shadow-none mt-10
          `}
        >
          <div className="flex items-center justify-between p-4 md:hidden">
            <button 
              onClick={toggleSidebar}
              className="text-gray-700 hover:text-orange-500 transition-colors"
            >
              <FaTimes size={24} />
            </button>
          </div>

          {/* Scrollable Content Container */}
          <div className="h-[calc(80vh-40px)] md:h-screen overflow-y-auto pb-8">
            <nav className="mt-4 md:mt-8">
              <ul>
                {sidebarItems.map((item, index) => (
                  <li key={index}>
                    <button
                      onClick={() => {
                        setActiveComponent(item.component);
                        setSearchParams({ tab: item.component });
                        setIsSidebarOpen(false);
                      }}
                      className={`
                        flex items-center w-full px-6 py-4 
                        text-gray-700 hover:bg-orange-50 hover:text-orange-500 
                        transition-colors duration-200
                        ${activeComponent === item.component 
                          ? "bg-orange-500 text-white" 
                          : ""
                        }
                      `}
                    >
                      <span className="text-lg">{item.icon}</span>
                      <span className="ml-4 font-semibold">{item.label}</span>
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>

        {/* Overlay */}
        {isSidebarOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
            onClick={toggleSidebar}
          />
        )}

        {/* Main Content */}
        <div className="flex-1 overflow-y-auto">
          <header className="flex items-center justify-between p-4 bg-white shadow-md md:hidden">
            <button onClick={toggleSidebar}>
              <FaBars size={24} className="text-gray-600 hover:text-e-ride-purple transition-colors duration-200" />
            </button>
          </header>

          {renderComponent()}
        </div>
      </div>
    </>
  );
};

export default JobDashboard;